var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-reviews"},[_c('headline',{attrs:{"bg":""}},[_vm._v(" Derniers Avis ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }